import { createSlice } from "@reduxjs/toolkit";

export interface AuthState {
  isRefreshing: boolean;
  favoriteProductIds: any[];
  corporateAccountsAsOwner: Object;
}

const AUTH_DEFAULT_STATE: AuthState = {
  isRefreshing: false,
  favoriteProductIds: [],
  corporateAccountsAsOwner: {},
};

export const authSlice = createSlice({
  name: "auth",
  initialState: AUTH_DEFAULT_STATE,
  reducers: {
    initUser: (_state, { payload }) => {
      return { ..._state, ...(payload || {}), isRefreshing: false };
    },
    loginUser: (_state, { payload }) => {
      return { ..._state, ...payload };
    },
    fetchUserProfile: (_state, { payload }) => {
      return { ..._state, ...payload, isRefreshing: false };
    },
    loginSuccess: (_state, { payload }) => {
      return { ..._state, ...payload, isRefreshing: false };
    },
    updateUser: (_state, { payload }) => {
      return { ..._state, ...payload };
    },
    logoutUser: () => {
      return AUTH_DEFAULT_STATE;
    },
    updateSession: (_state, { payload }) => {
      return { ..._state, ...payload, isRefreshing: false }; //check which keys are updating
    },
  },
});
